module.exports = __webpack_public_path__ + "img/Dantam Hair 43.8936158b.jpg";